/* ==========================================================
   MY RARE AURA — Recently Viewed Products
   Isolated, safe module. Creates the section only when products exist.
========================================================== */
(function () {
  'use strict';

  var KEY = 'aurelle_recently_viewed';
  var MAX = 8;

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[char];
    });
  }

  function getCurrentProduct() {
    var dataEl = document.getElementById('AurelleProductData');
    if (!dataEl) return null;

    try {
      var data = JSON.parse(dataEl.textContent.trim());
      if (!data || !data.id) return null;

      return {
        id: String(data.id),
        title: data.title || '',
        url: data.url || window.location.pathname,
        image: data.featured_image || '',
        price: data.price || ''
      };
    } catch (error) {
      console.warn('My Rare Aura Recently Viewed: product data could not be parsed.', error);
      return null;
    }
  }

  function getSavedProducts() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function saveCurrentProduct(current, saved) {
    var cleaned = saved
      .filter(function (item) {
        return item && item.id && String(item.id) !== String(current.id);
      })
      .map(function (item) {
        return {
          id: String(item.id),
          title: item.title || '',
          url: item.url || '#',
          image: item.image || '',
          price: item.price || ''
        };
      });

    localStorage.setItem(KEY, JSON.stringify([current].concat(cleaned).slice(0, MAX)));
    return cleaned;
  }

  function getMount() {
    var mount = document.getElementById('AurelleRecentlyViewedMount');

    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'AurelleRecentlyViewedMount';

      var footer = document.querySelector('footer, .shopify-section-group-footer-group');
      if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(mount, footer);
      } else {
        document.body.appendChild(mount);
      }
    }

    return mount;
  }

  function render(items) {
    var mount = getMount();
    mount.innerHTML = '';

    if (!items.length) return;

    var cards = items.map(function (item) {
      return [
        '<a class="aurelle-recent-card" href="' + escapeHTML(item.url) + '">',
          '<div class="aurelle-recent-card__image">',
            item.image ? '<img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(item.title) + '" loading="lazy">' : '',
          '</div>',
          '<p class="aurelle-recent-card__brand">My Rare Aura</p>',
          '<h3>' + escapeHTML(item.title) + '</h3>',
          '<span>' + escapeHTML(item.price) + '</span>',
        '</a>'
      ].join('');
    }).join('');

    mount.innerHTML = [
      '<section class="aurelle-recently-viewed has-items" id="AurelleRecentlyViewed">',
        '<p class="aurelle-related-kicker">Recently Viewed</p>',
        '<h2>Continue Exploring</h2>',
        '<p class="aurelle-related-subtitle">Pieces you viewed recently, saved on this device.</p>',
        '<div class="aurelle-recent-grid" id="AurelleRecentGrid">',
          cards,
        '</div>',
      '</section>'
    ].join('');
  }

  function initRecentlyViewed() {
    var current = getCurrentProduct();
    if (!current) return;

    var saved = getSavedProducts();
    var itemsToShow = saveCurrentProduct(current, saved).slice(0, MAX);

    render(itemsToShow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  } else {
    initRecentlyViewed();
  }

  window.addEventListener('pageshow', initRecentlyViewed);
})();
